import React from 'react'

function DashboardEventDetail() {
  return <>
   <div>Bu Sayfa Private EventDetail Sayfasıdır</div>
  </>
}

export default DashboardEventDetail